<script setup lang="ts">
import { computed, inject, PropType } from "vue";
import { useCategoryFilter } from "@/composables/filters/category-filter";
import { Category } from "@/types/entities";
import type { PagingFilter } from "@/composables/filters/paging-filter";
import { pagingFilterSymbol } from "@/plugins/ContentFiltersPlugin";
import { useUrlSearchParams } from '@vueuse/core';

const urlParams = useUrlSearchParams()
const { includeCategoryFilter, resetSelectedCategories, toggleSelectedCategory, prePopulateSelectedCategories } = useCategoryFilter();

const props = defineProps( {
  contentCategories: {
    type: Array as PropType< Category[] | undefined >,
    required: false
  } } );
const categories = computed< Category[] >( () => props.contentCategories ?? [] );

const pagingFilter = inject< PagingFilter >( pagingFilterSymbol ) as PagingFilter;

function resetPageNumber() {
  pagingFilter?.resetPageNumber();
}

// http://localhost:5173/learning/articles?category=tutorials&category=fstom
// Using both product & category parameters: http://localhost:5173/learning/articles?product=mega-trend-profit-club&category=weekly-update
if (urlParams.category) {
    const selectedCategories = Array.isArray(urlParams.category) ? urlParams.category : [urlParams.category];
    prePopulateSelectedCategories(selectedCategories);
}
const isCategorySelected = (category: Category) => {
  return includeCategoryFilter.value.some((c) => c.id === category.id);
};
</script>

<template>
<div class="border dark:border-surface-600 rounded p-3">
    <div class="flex justify-between">
        <div class="text-sm text-gray-400">Filter by Category</div>
        <button :class="{ disabled: !includeCategoryFilter.length }" class="btn btn-sm" @click="resetSelectedCategories">Clear</button>
    </div>
    <hr class="my-2">
    <div class="max-h-80 overflow-y-scroll divide-y px-2">
        <div v-for="( category, i ) in categories" :key="i + category.slug" @click="toggleSelectedCategory( category )" class="flex items-center gap-2 cursor-pointer py-4 text-sm">
        <input type="checkbox" @change="resetPageNumber" :checked="isCategorySelected( category )" class="checkbox">
        <div>{{ category.name }}</div>
        </div>
    </div>
</div>
</template>

